import { createSelector } from 'reselect';
import { IAction, IActionBasic } from 'types/domain/action';
import { selectAction } from './action';
import { selectActionRegister } from './actionRegister';
import { IActionRegister, RegisterResult } from 'core/slices/register';
import { RootState } from 'types';
import { EntityTypes } from 'constants/entities';
import { IEntityReducer } from 'core/reducers/entities';

const actionId = (state: RootState, id?) => id || state.state[EntityTypes.ACTION];
const entity = (state: RootState) => state.entity.present;
const actionRegister = selectActionRegister;

export const selectActionCanUpdate = createSelector(
  [entity, actionId, actionRegister],
  (entity: IEntityReducer, id: number, actionRegister: IActionRegister) => {
    const action: IAction = entity[EntityTypes.ACTION][id];

    return action && action.allowRetake
      ? true
      : actionRegister?.result
      ? actionRegister?.result === RegisterResult.INFO
      : true;
  },
);
